import React from "react";
import cx from "clsx";
import { contructItemUrl } from "./helpers";
export var ItemButton = function (_a) {
    var className = _a.className, label = _a.label, url = _a.url, urlType = _a.urlType;
    var layoutClass = "inline-block py-2 px-7 max-w-full";
    var textClass = "uppercase text-primary-200 text-sm font-semibold tracking-widest";
    var borderClass = "border border-primary-200 rounded-3xl";
    var transitionClass = "hover:bg-primary-50 transition-colors duration-200";
    var buttonClass = cx(className, layoutClass, textClass, borderClass, transitionClass);
    var href = contructItemUrl(url, urlType);
    return (React.createElement("a", { href: href, className: buttonClass, "data-testid": "item-buttom" }, label));
};
//# sourceMappingURL=ItemButton.js.map